import React from 'react';
import PropTypes from 'prop-types';
import {
    Avatar,
    List,
    ListItem,
    ListItemAvatar,
    ListItemText,
    DialogTitle,
    Dialog,
} from '@material-ui/core';
import {makeStyles} from '@material-ui/core/styles';

const useStyles = makeStyles(theme => ({
    avatar: {
        color: theme.palette.secondary.main,
        background: 'transparent',
    }
}));

const MMSeasDialog = ({onClose, open, label, options = []}) => {
    const classes = useStyles();

    return (
        <Dialog onClose={onClose} aria-labelledby="simple-dialog-title" open={open}>
            <DialogTitle id="simple-dialog-title">{label}</DialogTitle>
            <List>
                {options.map((option) => (
                    <ListItem button onClick={() => option.onClick()} key={option.name}>
                        <ListItemAvatar>
                            <Avatar className={classes.avatar}>
                                {option.icon}
                            </Avatar>
                        </ListItemAvatar>
                        <ListItemText primary={option.name} />
                    </ListItem>
                ))}
            </List>
        </Dialog>
    );
}

MMSeasDialog.propTypes = {
    onClose: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    selectedValue: PropTypes.string.isRequired,
};

export default MMSeasDialog;

// export default function SimpleDialogDemo() {
//     const [open, setOpen] = React.useState(false);
//     const [selectedValue, setSelectedValue] = React.useState(emails[1]);

//     const handleClickOpen = () => {
//         setOpen(true);
//     };

//     const handleClose = (value) => {
//         setOpen(false);
//         setSelectedValue(value);
//     };

//     return (
//         <div>
//             <Typography variant="subtitle1">Selected: {selectedValue}</Typography>
//             <br />
//             <Button variant="outlined" color="primary" onClick={handleClickOpen}>
//                 Open simple dialog
//             </Button>
//             <SimpleDialog selectedValue={selectedValue} open={open} onClose={handleClose} />
//         </div>
//     );
// }
